<template>

    <div id="messages-filter">
      <br/>
      <br/>
      <f7-list>
        <!-- Sélection des valeurs de Filtre -->
        <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <b-row class="mx-0" style="min-width: 100%">
            <b-col xl="8" class="pl-0">
              <b-row class="mx-0 d-flex">
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterEndToEndId()">
                  <span class="filter-item-title">{{ $t('filter.end_to_end_id') }}</span>
                  <span class="filter-item-content">
                    <input v-model="endToEndId"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': endToEndId}"
                      :placeholder="$t('filter.end_to_end_id')">
                    </input>
                  </span>
                </b-col>
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterMsgId()">
                  <span class="filter-item-title">{{ $t('pacs008.msgId') }}</span>
                  <span class="filter-item-content">
                    <input v-model="requestIdentifiersct"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': requestIdentifiersct}"
                      :placeholder="$t('pacs008.msgId')">
                    </input>
                  </span>
                </b-col>
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterFileName()">
                  <span class="filter-item-title">{{ $t('pacs008.msgId') }}</span>
                  <span class="filter-item-content">
                    <input v-model="requestIdentifier"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': requestIdentifier}"
                      :placeholder="$t('pacs008.msgId')">
                    </input>
                  </span>
                </b-col>
                <!-- Filtre creditor et debtor -->
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterIbanCreditor()">
                  <span class="filter-item-title">{{ $t('filter.creditor_iban') }}</span>
                  <span class="filter-item-content">
                    <input v-model="ibanCreditor"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': ibanCreditor}"
                      :placeholder="$t('filter.creditor_iban')">
                    </input>
                  </span>
                </b-col>
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterBicDebtor()">
                  <span class="filter-item-title">{{ $t('pacs008.debtor_bic') }}</span>
                  <span class="filter-item-content">
                    <input v-model="bicDebtor"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': bicDebtor}"
                      :placeholder="$t('pacs008.debtor_bic')">
                    </input>
                  </span>
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterDirection()">
                  <span class="filter-item-title" style="margin-left: 2px">
                    {{ $t('pacs008.direction') }}
                  </span>
                  <span class="filter-item-content d-flex">
                    <select id="sel2"
                    v-model="direction"
                    style="cursor: pointer; font-size: 13px; height: auto; z-index: 2; color: #969696">
                      <option value="">{{ $t('pacs008.select_direction') }}</option>
                      <option v-for="direction in dirL" :key="direction.code" :value="direction.code">
                        {{ direction.label }}
                      </option>
                    </select>
                    <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"
                      style="cursor: pointer; margin-left: -20px; z-index: 1">
                    </i>
                  </span>
                </b-col>
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterNamePacs()">
                  <span class="filter-item-title">{{ $t('pacs008.file_name_pacs') }}</span>
                  <span class="filter-item-content">
                    <input v-model="namePacs"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': namePacs}"
                      :placeholder="$t('pacs008.file_name_pacs')">
                    </input>
                  </span>
                </b-col>

                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterStatus()">
                  <!-- :cols="showFilterNamePacs() ? '6' : '12'" :offset-xl="showFilterNamePacs() ? '0' : '3'" -->
                  <span class="filter-item-title" style="margin-left: 2px">
                    {{ $t('pain008.stat_global_imported_file') }}
                  </span>
                  <span class="filter-item-content d-flex">
                    <select id="sel2"
                    v-model="status"
                    style="cursor: pointer; font-size: 13px; height: auto; z-index: 2; color: #969696">
                      <option value="">{{ $t('acceptance.select_stat') }}</option>
                      <option v-for="status in statusL" :key="status.code" :value="status.code">
                        {{ status.label }}
                      </option>
                    </select>
                    <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"
                      style="cursor: pointer; margin-left: -20px; z-index: 1">
                    </i>
                  </span>
                </b-col>

                <!-- Filtre date de début -->
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterDateBegin()">
                  <span class="filter-item-title">
                    {{ $t('common.date_start_label') }}</span>
                  <span class="filter-item-content">
                    <input v-model="dateBegin"
                      type="date"
                      :class="{'cursor filter-item-input': true, 'cursor filter-item-input-complete': dateBegin}"
                      :placeholder="$t('common.slct_date')">
                    </input>
                  </span>
                </b-col>

                <!-- Filtre date de fin -->
                <b-col xl="3" cols="6" class="filter-item mb-3 pl-0" v-if="showFilterDateEnd()">
                  <span class="filter-item-title">
                    {{ $t('common.date_end_label') }}
                  </span>
                  <span class="filter-item-content">
                    <input v-model="dateEnd"
                      type="date"
                      :class="{'cursor filter-item-input': true, 'cursor filter-item-input-complete': dateEnd}"
                      :placeholder="$t('common.slct_date')">
                    </input>
                    <div v-if="isEndDateInvalid" class="error-message text-danger">{{ $t('common.error_end_date_invalid') }}</div>
                  </span>
                </b-col>
              </b-row>


              <!--
              <div class="filter-item">
                <span>
                  <b-form-checkbox style="margin-top: 20px; margin-left: 10px">
                  <span class="filter-item-title">
                    {{ $t('pain008.closed') }}
                  </span>
                  </b-form-checkbox>
                </span>
              </div> -->
            </b-col>

            <!-- Bouton Effacer et Appliquer et le nombre de résultats retournés -->
            <b-col xl="1" cols="6" class="my-auto text-right">
                <b-button class="btn" size="sm"
                @click="clearFilterFields"
                :disabled="!hasInputFilter"
                style="width: 80px; height: 28px">
                <i class="fa-solid fa-xmark"></i>
              </b-button>
            </b-col>
            <b-col xl="1" cols="6" class="my-auto text-left">
              <b-button class="btn btnApplyFilter" size="sm"
                @click="applyFilter(modeFilter)">
                <i class="fa-light fa-magnifying-glass" size="17px"></i>
              </b-button>
            </b-col>
            <b-col xl="2" class="showLargeScreenOnly my-auto text-right">
              <b> {{countResults}} {{ $t('pain008.returned_result') }} </b>
            </b-col>
            <b-col xl="2" cols="12" class="showSmallScreenOnly mt-5 text-center">
              <b> {{countResults}} {{ $t('pain008.returned_result') }} </b>
            </b-col>
          </b-row>

        </f7-list-item>
      </f7-list>
    </div>

  </template>

  <script>
  import datePickerMixin from '@/mixins/datePickerMixin'
  import services from '@/helpers/services.js'
  import Status from "@/helpers/status.js"
  import { statusLabel, statusIcon } from "@/helpers/labels"

  export default {
    mixins: [datePickerMixin],
    name: 'MessagesFilter',
    props: {
      countResults: {
        type: String,
        default: false
      },
      filterType: {
        type: String,
        default: 'list'
      },
      format: {
        type: String,
        default: ''
      },
      mode: {
        type: Number,
        default: 1
      },
      propedServiceId: {
        type: String,
        default: 'none'
      },
      randomId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        bicDebtor: '',
        CurrentNameFile: '',
        CurrentFormat: '',
        CurrentIdFormat: '',
        dateBegin: '',
        dateEnd: '',
        dir: 0,
        displayFilter: true,
        endToEndId: '',
        fileName: '',
        filterTypeGet: 'list',
        hasDefaultFilter: false,
        ibanCreditor: '',
        ibanDebtor: '',
        modeFilter: this.mode,
        msgId: '',
				namePacs: '',
        randomString: '',
        requestIdentifier: '',
        requestIdentifiersct: '',
        serviceId: '',
        services: services,
        status: '',
        direction: '',
        statusL: [
          {
            code: 5,
            label: statusLabel(this.$i18n, 'pacs008_05')
          },
          {
            code: 1,
            label: statusLabel(this.$i18n, 'pacs008_01')
          },
          {
            code: 2,
            label: statusLabel(this.$i18n, 'pacs008_02')
          },
          {
            code: 13,
            label: statusLabel(this.$i18n, 'pacs008_013')
          },
          {
            code: 14,
            label: statusLabel(this.$i18n, 'pacs008_014')
          },
          {
            code: 16,
            label: statusLabel(this.$i18n, 'pacs008_016')
          },
          {
            code: 17,
            label: statusLabel(this.$i18n, 'pacs008_017')
          },
          {
            code: 19,
            label: statusLabel(this.$i18n, 'pacs008_019')
          },
          {
            code: 20,
            label: statusLabel(this.$i18n, 'pacs008_020')
          }
        ],
        dirL: [
          {
            code: 0,
            label: statusLabel(this.$i18n, 'reception')
          },
          {
            code: 1,
            label: statusLabel(this.$i18n, 'emission')
          },
        ]
      }
    },
    created () {
      if (this.propedServiceId === 'none') {
        this.serviceId = this.$engine.user.currentService.id
      } else {
        this.serviceId = this.propedServiceId
      }
      this.filterTypeGet = this.filterType

      this.$bus.on('service:change', (val) => {
        this.serviceId = this.$engine.services.getServiceIdByName(val)
      })
      this.$bus.emit('right-panel-set-feature', 'filter-messages')

      // Command "apply filter" from the right-panel-filter-view (mobile)
      this.$bus.on('filter-apply-filter-' + this.randomId, (filter = {}) => {
        if (Object.keys(filter).length) {
          this.applyFilter(1, filter)
        } else {
          this.applyFilter()
        }
      })
      // Command "clear filter fields" from the right-panel-filter-view (mobile)
      this.$bus.on('filter-clear-filter-fields', () => {
        this.clearFilterFields()
      })
      // Command "save filter" from the right-panel-filter-view (mobile)
      this.$bus.on('filter-save-filter', () => {
        this.saveDefaultFilter()
      })
      // Command "delete filter" from the right-panel-filter-view (mobile)
      this.$bus.on('filter-delete-filter', () => {
        this.deleteFilter()
      })

      // Intercepts filter changes from the right-panel-filter-view (mobile)
      this.$bus.on('filter-update-fields', (filter) => {
        for (const property in filter) {
          if (this.statusList[property] !== undefined) {
            // Set filter status values
            this.statusList[property].state = filter[property]
          } else {
            // Set filter other values
            this[property] = filter[property]
          }
        }
      })

      if (this.$engine.pacs008.CurrentMsgIdSCT) {
        this.requestIdentifiersct = this.$engine.pacs008.CurrentMsgIdSCT
      }

      if (this.$engine.pacs008.CurrentNameFile) {
        this.CurrentNameFile = this.$engine.pacs008.CurrentNameFile
      }

      if (this.$engine.pacs008.CurrentFormat) {
        this.CurrentFormat = this.$engine.pacs008.CurrentFormat
      }

      if (this.$engine.pacs008.CurrentIdFormat) {
        this.CurrentIdFormat = this.$engine.pacs008.CurrentIdFormat
      }

      if (this.$engine.pacs008.CurrentNameFile && this.$engine.pacs008.CurrentFormat && this.$engine.pacs008.CurrentIdFormat) {
        this.requestIdentifier = this.$engine.pacs008.CurrentNameFile + "_" + this.$engine.pacs008.CurrentFormat + "_" + this.$engine.pacs008.CurrentIdFormat
      }
    },
    mounted () {
      this.dir = this.$settings.msgDirection
      this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

      let actualService = this.getActualService()
      var defaultFilter = {}
      switch (this.filterTypeGet) {
        case 'details':
          defaultFilter = actualService.filterDetails.getDefaultFilter()
          if (this.modeFilter === 2) {
            defaultFilter.statusDocRejected = 1
            defaultFilter.statusDocValidated = 1
          }
          break
        case 'draft':
          defaultFilter = actualService.filterDraft.getDefaultFilter()
          break
        case 'group':
          defaultFilter = actualService.filterGroup.getDefaultFilter()
          break
        case 'list':
          defaultFilter = actualService.filter.getDefaultFilter()
          break
        default:
          break
      }

      // Set default filter values
      this.setDefaultFilter(defaultFilter)

      // Warns right-panel-filter-view (mobile) that default values have been applied
      this.communicateChange()
    },
    beforeDestroy () {
      // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
      this.$bus.off('service:change')
      this.$bus.off('filter-update-fields')
      this.$bus.off('filter-apply-filter-' + this.randomId)
      this.$bus.off('filter-save-filter')
      this.$bus.off('filter-delete-filter')
      this.$bus.off('filter-update-fields')
    },
    computed: {
      filterFields () {
        let that = this
        let filter = {}

        // Date, Reason and Name values
        filter.dateBegin = this.dateBegin
        filter.dateEnd = this.dateEnd
        filter.creditor = this.creditor
        filter.debtor = this.debtor
        filter.ibanCreditor = this.ibanCreditor
        filter.ibanDebtor = this.ibanDebtor
        filter.bicDebtor = this.bicDebtor
        filter.endToEndId = this.endToEndId
        filter.msgId = this.msgId
        filter.fileName = this.fileName
        filter.direction = this.direction
        filter.CurrentNameFile = this.CurrentNameFile
        filter.CurrentFormat = this.CurrentFormat
        filter.CurrentIdFormat = this.CurrentIdFormat
        filter.requestIdentifier = this.requestIdentifier
        filter.requestIdentifiersct = this.requestIdentifiersct

        // Status values
        for (let property in this.statusList) {
          let status = that.statusList[property]
          filter[property] = status.state
        }

        return filter
      },
      hasInputFilter () {
        if ((this.statusDisplay.nb > 0 && this.modeFilter !== 2) ||
          this.status !== undefined && this.status !== '' ||
          this.dateBegin ||
          this.dateEnd ||
          this.creditor ||
          this.debtor ||
					this.namePacs ||
					this.ibanCreditor ||
					this.ibanDebtor ||
          this.bicDebtor ||
					this.endToEndId ||
          this.msgId ||
          this.fileName ||
          this.CurrentNameFile ||
          this.CurrentFormat ||
          this.CurrentIdFormat ||
          this.requestIdentifier ||
          this.requestIdentifiersct ||
          (this.direction || this.direction === 0)) {
          return true
        }
        return false
      },
      isEndDateInvalid() {
        return !this.validateEndDate()
      },
      isSmartphoneOS () {
        return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
      },
      realStatusList () {
        let that = this
        const list = []
        for (const property in that.statusList) {
          const status = that.statusList[property]
          list.push({
            tag: property,
            label: status.label,
            icon: status.icon,
            state: status.state
          })
        }
        return list
      },
      statusDisplay () {
        let realStatusList = this.realStatusList.filter(status => status.state === 1)
        if (realStatusList.length === 0) {
          return {
            label: this.$t('filter.selected_status_none'),
            nb: 0
          }
        } else if (realStatusList.length === 1) {
          return {
            label: realStatusList[0].label,
            icon: realStatusList[0].icon,
            nb: 1
          }
        } else {
          let finalLabel
          if (realStatusList.length === this.realStatusList.length) {
            finalLabel = this.$t('pain008.select_all')
          } else {
            finalLabel = realStatusList[0].label
            for (let i = 1; i < realStatusList.length; i++) {
              finalLabel += ', ' + realStatusList[i].label
            }
          }
          return {
            label: finalLabel,
            nb: realStatusList.length
          }
        }
      }
    },
    methods: {
      applyFilter (mode = 1, filterConditions = {}) {
        let that = this

        let actualService = this.getActualService()
        let actualFilter = actualService.filter
        actualFilter.cleanFilterCondition()

        for (let property in this.statusList) {
          let status = that.statusList[property]
          actualFilter[property] = status.state
        }

        actualFilter.dateBegin = this.dateBegin
        actualFilter.dateEnd = this.dateEnd ? (this.dateEnd + 'T23:59:59') : ''
        actualFilter.creditor = this.creditor
        actualFilter.debtor = this.debtor
        actualFilter.status = this.status
        actualFilter.namePacs = this.namePacs
        actualFilter.endToEndId = this.endToEndId
        actualFilter.msgId = this.msgId
        actualFilter.fileName = this.fileName
        actualFilter.CurrentNameFile = this.CurrentNameFile
        actualFilter.CurrentFormat = this.CurrentFormat
        actualFilter.CurrentIdFormat = this.CurrentIdFormat
        actualFilter.ibanDebtor = this.ibanDebtor
        actualFilter.bicDebtor = this.bicDebtor
        actualFilter.ibanCreditor = this.ibanCreditor
        actualFilter.direction = this.direction
        actualFilter.requestIdentifier = this.requestIdentifier
        actualFilter.requestIdentifiersct = this.requestIdentifiersct
        actualFilter.modeFilter = mode

        // console.log('actualfilter in index', actualFilter)

        for (let propertyCustom in filterConditions) {
          actualFilter[propertyCustom] = filterConditions[propertyCustom]
        }

        // console.log("applyFilter", actualFilter, actualFilter.getConditionObject())

        this.$emit('applyFilter', actualFilter.getConditionObject())
      },
      clearFilterFields () {
        let that = this
        for (let property in that.statusList) {
          that.statusList[property].state = 0
        }

        if (this.modeFilter === 2 && this.serviceId === services.DOCUMENTSERVICE) {
          that.statusList.statusDocRejected.state = 1
          that.statusList.statusDocValidated.state = 1
        }

        this.dateBegin = ''
        this.dateEnd = ''
        this.creditor= ''
        this.status = ''
        this.debtor= ''
        this.namePacs =''
				this.ibanCreditor = ''
        this.ibanDebtor = ''
        this.bicDebtor = ''
        this.endToEndId = ''
        this.msgId = ''
        this.fileName = ''
        this.CurrentNameFile = ''
        this.CurrentFormat = ''
        this.CurrentIdFormat = ''
        this.direction = ''
        this.requestIdentifier = ''
        this.requestIdentifiersct = ''
        this.communicateChange()
      },
      communicateChange () {
        this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
      },
      deleteFilter () {
        let actualService = this.getActualService()
        switch (this.filterTypeGet) {
          case 'details':
            actualService.filterDetails.saveDefaultFilter({})
            break
          case 'draft':
            actualService.filterDraft.saveDefaultFilter({})
            break
          case 'group':
            actualService.filterGroup.saveDefaultFilter({})
            break
          case 'list':
            actualService.filter.saveDefaultFilter({})
            break
          default:
            actualService.filter.saveDefaultFilter({})
            break
        }
        this.hasDefaultFilter = false
        this.$f7.modal({
          title: 'Filtre supprimé',
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      },
      getActualService () {
        let serviceName = {
          '10': this.$engine.pacs008
        }
        return serviceName[this.serviceId]
      },
      saveDefaultFilter () {
        let that = this

        let actualService = this.getActualService()

        let defaultFilter = {
          dateBegin: this.dateBegin,
          dateEnd: this.dateEnd,
          creditor: this.creditor,
          debtor: this.debtor,
          namePacs: this.namePacs,
          direction: this.direction
        }

        for (const property in this.statusList) {
          let status = that.statusList[property]
          defaultFilter[property] = status.state
        }

        switch (this.filterTypeGet) {
          case 'details':
            actualService.filterDetails.saveDefaultFilter(defaultFilter)
            break
          case 'draft':
            actualService.filterDraft.saveDefaultFilter(defaultFilter)
            break
          case 'group':
            actualService.filterGroup.saveDefaultFilter(defaultFilter)
            break
          case 'list':
            actualService.filter.saveDefaultFilter(defaultFilter)
            break
          default:
            actualService.filter.saveDefaultFilter(defaultFilter)
            break
        }

        if (this.hasInputFilter) {
          this.hasDefaultFilter = true
        }

        that.$f7.modal({
          title: this.$i18n.t('filter.dflt_fltr_svd'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      },
      setDefaultFilter (defaultFilter) {
        for (const property in defaultFilter) {
          if (this.statusList[property] !== undefined) {
            // Set filter status values
            this.statusList[property].state = defaultFilter[property]
            if (defaultFilter[property] === 1) {
              this.hasDefaultFilter = true
            }
          } else {
            // Set filter other values
            if (property !== 'modeFilter') {
              this[property] = defaultFilter[property]
              if (this[property]) {
                this.hasDefaultFilter = true
              }
            }
          }
        }
      },
      showFilterBicDebtor () {
        return this.$engine.user.currentService.id !== '7' &&
          this.$engine.user.currentService.id !== '8' &&
          !this.isHistory && !this.isVerifications
      },
      showFilterDateBegin () {
        return true
      },
      showFilterDateEnd () {
        return true
      },
      showFilterIbanCreditor () {
        return true
      },
      showFilterIbanDebtor () {
        return true
      },
      showFilterEndToEndId () {
        return true
      },
      showFilterMsgId () {
        return this.format === 'SCT'
      },
      showFilterFileName () {
        return this.format === 'SDD'
      },
      showFilterNamePacs () {
        return this.format === 'SDD'
      },
      showFilterStatus () {
        return true
      },
      showFilterDirection () {
        return this.format === 'SCT'
      },
      validateEndDate() {
        if (this.dateEnd && this.dateBegin && this.dateEnd < this.dateBegin) {
          return false
        }
        return true
      }
    },
    watch: {
      creditor () {
        this.communicateChange()
      },
      dateBegin () {
        this.communicateChange()
      },
      dateEnd () {
        this.communicateChange()
      },
      debtor () {
        this.communicateChange()
      },
      hasDefaultFilter () {
        this.communicateChange()
      },
      statusList: {
        deep: true,
        handler () {
          this.communicateChange()
        }
      }
    }
  }
  </script>
